module.exports = __webpack_public_path__ + "static/media/8OLA18.733e62e8.jpg";